import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {showConstructionPhaseInfoModal} from '../../../redux/actions';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {selectPhase} from '../../../redux/reducers/sharedStateReducer/selectors';
import {PHASES} from '../../../constants/phases';
import {RULES_SECTION_IDS, RULES_SECTIONS} from '../../Modals/RulesModal/rulesSections';
import {MASKED_ICON_TONES, MaskedIcon} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {GAME_BUTTON_SIZES, GAME_BUTTON_VARIANTS, GameButton} from '../../gameUi/GameButton';

// Раздел правил, соответствующий текущей фазе — кнопка показывается во всех
// игровых фазах (см. Footer.js), у SETUP/FIELD_PREPARATION своего раздела
// нет, для них (как и вне игры) используется общий обзор
const PHASE_TO_RULES_SECTION_ID = {
  [PHASES.SUPPLY]: RULES_SECTION_IDS.SUPPLY_PHASE,
  [PHASES.CONSTRUCTION]: RULES_SECTION_IDS.CONSTRUCTION_PHASE,
  [PHASES.WAR]: RULES_SECTION_IDS.WAR_PHASE,
};

const InfoButton = () => {
  const dispatch = useDispatch();
  const phase = useSelector(selectPhase);

  const targetSectionId = PHASE_TO_RULES_SECTION_ID[phase] || RULES_SECTION_IDS.OVERVIEW;
  const targetSection = RULES_SECTIONS.find((section) => section.id === targetSectionId);

  const handleClick = () => {
    REGISTRY_SINGLETON.getSoundManager().playSideMenuClick();
    dispatch(showConstructionPhaseInfoModal(targetSectionId));
  };

  return (
    <GameButton
      variant={GAME_BUTTON_VARIANTS.SUNK}
      size={GAME_BUTTON_SIZES.ICON}
      onClick={handleClick}
      className="footer-heading-btn"
      title={`Информация: ${targetSection?.label || 'Правила'}`}
    >
      <MaskedIcon
        src={'/img/icons/info.png'}
        alt={'info'}
        tone={MASKED_ICON_TONES.CONTROLS}
      />
    </GameButton>
  );
};

export default InfoButton;
